import { Languages } from 'lucide-react';

import { Button } from '@/components/lumen/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '@/components/lumen/dropdown-menu';
import { LANGUAGES, type LanguageCode } from '@constants/translations';
import { useLanguage } from '@contexts/LanguageContext';
import { HAPTIC, haptic } from '@utils/haptic';

const isLanguageCode = (value: string): value is LanguageCode => LANGUAGES.some((l) => l.code === value);

/**
 * The sign-in's language switch: the same choices and the same `setLanguage` as the old
 * LanguageSwitcher (stored in `jarvisLanguage`; pushed to the profile only with a session).
 */
export function AuthLanguageSwitch() {
  const { language, setLanguage, meta, t } = useLanguage();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" onClickCapture={() => haptic(HAPTIC.medium)}>
          <span className="text-base leading-none" aria-hidden="true">
            {meta.flag}
          </span>
          <span>{t('language.switcher')}</span>
          <Languages className="text-fg-muted" aria-hidden="true" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-44">
        <DropdownMenuRadioGroup
          value={language}
          onValueChange={(value) => {
            if (isLanguageCode(value)) setLanguage(value);
          }}
        >
          {LANGUAGES.map((lang) => (
            <DropdownMenuRadioItem key={lang.code} value={lang.code}>
              <span className="text-base leading-none" aria-hidden="true">
                {lang.flag}
              </span>
              {lang.label}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
